// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2f-8p","colBig":"styles_colBig__1qvEv","colSmall":"styles_colSmall__3-h-D"};